import { render } from "./AIChatView.vue?vue&type=template&id=428d22c0&scoped=true"
import script from "./AIChatView.vue?vue&type=script&lang=js"
export * from "./AIChatView.vue?vue&type=script&lang=js"

import "./AIChatView.vue?vue&type=style&index=0&id=428d22c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-428d22c0"]])

export default __exports__